// Vuex store.
import medicine from './medicine';
import patient from './patient';
import user from './user';
import fcfs from './fcfs';
import vital from './vital';
import appointment from './appointment';
import prescription from './prescription';
import reminder from './reminder';
import doctor from './doctor';

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    medicine,
    patient,
    user,
    fcfs,
    vital,
    appointment,
    prescription,
    doctor,
    reminder
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js